// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message_center_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { MessageSettings, MessageTranslation } from "./message_preferences_pb";
import { file_message_preferences } from "./message_preferences_pb";
import type { MessageRule } from "./message_rule_pb";
import { file_message_rule } from "./message_rule_pb";
import type { MessageType } from "./message_type_pb";
import { file_message_type } from "./message_type_pb";
import type { EventType } from "./event_type_pb";
import { file_event_type } from "./event_type_pb";
import type { Campaign } from "./campaign_pb";
import { file_campaign } from "./campaign_pb";
import type { ReservationService } from "./reservation_service_pb";
import { file_reservation_service } from "./reservation_service_pb";
import type { Tab } from "./tab_pb";
import { file_tab } from "./tab_pb";
import type { Handlebar } from "./handlebar_pb";
import { file_handlebar } from "./handlebar_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file message_center_service.proto.
 */
export const file_message_center_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_empty, file_message_preferences, file_message_rule, file_message_type, file_event_type, file_campaign, file_reservation_service, file_tab, file_handlebar]);

/**
 * preferences
 *
 * @generated from message grpc.api.v1.MessageCenterResponse
 */
export type MessageCenterResponse = Message<"grpc.api.v1.MessageCenterResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MessageSettings settings = 1;
   */
  settings?: MessageSettings | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTranslation translations = 2;
   */
  translations: MessageTranslation[];

  /**
   * @generated from field: repeated grpc.api.v1.MessageType messageTypes = 3;
   */
  messageTypes: MessageType[];

  /**
   * @generated from field: repeated grpc.api.v1.EventType eventTypes = 4;
   */
  eventTypes: EventType[];

  /**
   * @generated from field: repeated grpc.api.v1.Campaign campaigns = 5;
   */
  campaigns: Campaign[];

  /**
   * @generated from field: repeated grpc.api.v1.ReservationService services = 6;
   */
  services: ReservationService[];

  /**
   * @generated from field: repeated grpc.api.v1.Tab tabs = 7;
   */
  tabs: Tab[];

  /**
   * @generated from field: repeated grpc.api.v1.Handlebar handlebars = 8;
   */
  handlebars: Handlebar[];
};

/**
 * Describes the message grpc.api.v1.MessageCenterResponse.
 * Use `create(MessageCenterResponseSchema)` to create a new message.
 */
export const MessageCenterResponseSchema: GenMessage<MessageCenterResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 0);

/**
 * @generated from message grpc.api.v1.MessageCenterPreferencesRequest
 */
export type MessageCenterPreferencesRequest = Message<"grpc.api.v1.MessageCenterPreferencesRequest"> & {
  /**
   * @generated from field: grpc.api.v1.MessageSettings settings = 1;
   */
  settings?: MessageSettings | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTranslation translations = 2;
   */
  translations: MessageTranslation[];
};

/**
 * Describes the message grpc.api.v1.MessageCenterPreferencesRequest.
 * Use `create(MessageCenterPreferencesRequestSchema)` to create a new message.
 */
export const MessageCenterPreferencesRequestSchema: GenMessage<MessageCenterPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 1);

/**
 * @generated from message grpc.api.v1.MessageCenterPreferencesResponse
 */
export type MessageCenterPreferencesResponse = Message<"grpc.api.v1.MessageCenterPreferencesResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MessageSettings settings = 1;
   */
  settings?: MessageSettings | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTranslation translations = 2;
   */
  translations: MessageTranslation[];
};

/**
 * Describes the message grpc.api.v1.MessageCenterPreferencesResponse.
 * Use `create(MessageCenterPreferencesResponseSchema)` to create a new message.
 */
export const MessageCenterPreferencesResponseSchema: GenMessage<MessageCenterPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 2);

/**
 * rules
 *
 * @generated from message grpc.api.v1.MessageRuleIdRequest
 */
export type MessageRuleIdRequest = Message<"grpc.api.v1.MessageRuleIdRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message grpc.api.v1.MessageRuleIdRequest.
 * Use `create(MessageRuleIdRequestSchema)` to create a new message.
 */
export const MessageRuleIdRequestSchema: GenMessage<MessageRuleIdRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 3);

/**
 * @generated from message grpc.api.v1.MessageRuleRequest
 */
export type MessageRuleRequest = Message<"grpc.api.v1.MessageRuleRequest"> & {
  /**
   * @generated from field: grpc.api.v1.MessageRule rule = 1;
   */
  rule?: MessageRule | undefined;
};

/**
 * Describes the message grpc.api.v1.MessageRuleRequest.
 * Use `create(MessageRuleRequestSchema)` to create a new message.
 */
export const MessageRuleRequestSchema: GenMessage<MessageRuleRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 4);

/**
 * @generated from message grpc.api.v1.MessageRuleResponse
 */
export type MessageRuleResponse = Message<"grpc.api.v1.MessageRuleResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MessageRule rule = 1;
   */
  rule?: MessageRule | undefined;
};

/**
 * Describes the message grpc.api.v1.MessageRuleResponse.
 * Use `create(MessageRuleResponseSchema)` to create a new message.
 */
export const MessageRuleResponseSchema: GenMessage<MessageRuleResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 5);

/**
 * @generated from service grpc.api.v1.MessageCenterService
 */
export const MessageCenterService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.getMessageCenter
   */
  getMessageCenter: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof MessageCenterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.listMessageRules
   */
  listMessageRules: {
    methodKind: "server_streaming";
    input: typeof EmptyRequestSchema;
    output: typeof MessageRuleResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessagePreferences
   */
  updateMessagePreferences: {
    methodKind: "unary";
    input: typeof MessageCenterPreferencesRequestSchema;
    output: typeof MessageCenterPreferencesResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessagePreferencesSetLocalePriorityMode
   */
  updateMessagePreferencesSetLocalePriorityMode: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof MessageCenterPreferencesResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessageLanguagePreferences
   */
  updateMessageLanguagePreferences: {
    methodKind: "unary";
    input: typeof MessageCenterPreferencesRequestSchema;
    output: typeof MessageCenterPreferencesResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.getMessageRule
   */
  getMessageRule: {
    methodKind: "unary";
    input: typeof MessageRuleIdRequestSchema;
    output: typeof MessageRuleResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessageRule
   */
  updateMessageRule: {
    methodKind: "unary";
    input: typeof MessageRuleRequestSchema;
    output: typeof MessageRuleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_message_center_service, 0);

